import { ChangeDetectionStrategy, Component, Inject, OnInit} from '@angular/core';

import {
    ApplicationFacade,
    OnDemandTripsFacade,
    RidePlannerFacade,
} from '@ridango/components';
import { OnDemandPublicTrip } from '@ridango/core';
import { MapApiService } from '../../map/services';


@Component({
    selector: 'rwidget-ondemand-trips',
    templateUrl: './ondemand-trips.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OndemandTripsComponent implements OnInit {
    dateFormat = this.env.PRIMARY_DATE_FORMAT_MOMENT;
    assetsPath$ = this.applicationFacade.assetsPath$;

    potentialStops$ = this.ridePlanner.potentialStops$;
    trips$ = this.onDemand.trips$;
    selectedTrip$ = this.onDemand.selectedTrip$;
    loading$ = this.onDemand.loading$;

    constructor(
        private ridePlanner: RidePlannerFacade,
        private applicationFacade: ApplicationFacade,
        private onDemand: OnDemandTripsFacade,
        private mapApi: MapApiService,
        @Inject('ENV') public env: any
    ) {}

    ngOnInit() {
        this.ridePlanner.fetchStopsByRegion('');
        this.onDemand.fetchUpcomingTrips();
    }

    select(trip: OnDemandPublicTrip) {
        this.onDemand.addPolyline('');
        this.onDemand.setSelectedTrip(trip);
        const bounds = [];
        trip.stops.forEach(stop => {
            bounds.push([stop.latitude, stop.longitude]);
        });
        this.mapApi.fitBounds(bounds);
        if (trip?.shape_polyline) {
            setTimeout(() => this.onDemand.addPolyline(trip.shape_polyline), 300);
        }
    }

    back() {
        this.onDemand.setSelectedTrip(null);
        this.onDemand.addPolyline(null);
    }
}
